import axios from 'axios';
import { getMicroServiceUrl } from '../helpers/helpers';

export const getRoiData = (locationId) => ({
  type: 'GET_ROI_DATA',
  payload: axios.get(`${getMicroServiceUrl('data')}roiData/${locationId}`),
});
